"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("../Support/BaseUri");
function sprite(libraryId, pomSize, columns) {
    return BaseUri.compose()
        .segment(['yarns', 'libraries', "" + libraryId, 'sprite'])
        .query({ pomSize: pomSize, columns: columns })
        .toString();
}
exports.sprite = sprite;
